import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const StyledBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.common.white,
  padding: '15px',
  borderRadius: theme.shape.customBorderRadius.main,
  '&:focus': {
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
  },
  '&.small': {
    width: '40%',
  },
  '&.medium': {
    width: '600px',
  },
  '&.medium-x': {
    width: '55%',
  },
  '&.large': {
    width: '70%',
  },
}))
